
/**
 * 新的推送对象配置
 * @returns 
 */
const pushReceiverMap = {
    "title": "接收对象",
    "required": true,
    "x-decorator": "CnFormItem",
    "x-component": "FormFieldGroup",
    "x-component-props": {
        "layout": "horizontal",
        "properties": {
            "type": {
                "title": "",
                "required": true,
                "x-decorator": "CnFormItem",
                "x-component": "CnSelect",
                "x-component-props": {
                    "size": "small",
                    "useDetailValue": false,
                    "mode": "multiple",
                    "dataSource": [
                        {
                            "value": "ONESELF",
                            "label": "自己"
                        },
                        {
                            "value": "SPECIFY_MEMBERS",
                            "label": "指定人员"
                        }
                    ]
                }
            },
            "specifyMembers": {
                "title": "",
                "required": true,
                "x-decorator": "CnFormItem",
                "x-component": "CustomRemoteSelect",
                "x-component-props": {
                    "size": "small",
                    "useDetailValue": true,
                    "showSearch": true,
                    "mode": "multiple",
                    "placeholder": "请选择指定人员",
                    "remoteConfig": {
                        "url": "/subscription/getSubscribeUserList",
                        "method": "GET",
                        "params": {
                            "reportType": "POLICY_CRM_WEEK_REPORT"
                        }
                    }
                },
                "x-condition": {
                    "dependsOn": "type",
                    "when": "dependValue?.includes('SPECIFY_MEMBERS')"
                }
            }
        }
    }
}

/**
 * 将旧的【推送对象】结构转为新的【推送对象】组件结构
 * @param schema 
 * @returns 
 */
export const convertPushReceiver = (schema: any, config: any) => {
  const newSchema = JSON.parse(schema);
  let newConfig = config;
  // 旧的【推送对象】结构转为新的推送对象组件结构
  newSchema.properties.pushCard.properties.pushReceiverMap = pushReceiverMap;
  // 如果存在旧的【推送对象】结构
  if (newSchema.properties.pushCard.properties.pushReceiver) {
    const defaultValues = {
      "type": ["ONESELF"],
    };
    newConfig = { ...newConfig, pushReceiverMap: defaultValues };
    // 删除旧的【推送对象】结构
    delete newSchema.properties.pushCard.properties.pushReceiver;
    delete newSchema.properties.extraInfo.params.initialValues.pushReceiver;
    delete newConfig.pushReceiver;
  }
  return { schema: JSON.stringify(newSchema), config: newConfig };
}